import React from 'react'
import { TypographyV2 as Typography } from '@which/seatbelt'
import type { Link as LinkType } from '@which/transform/build/generated/backend'

import { Link } from '../../../../shared/components/Link'
import styles from './RelatedLinks.module.scss'

interface Props {
  relatedLinks: LinkType[]
}

export const RelatedLinks: React.FC<Props> = ({ relatedLinks }) => (
  <>
    <Typography textStyle="sb-text-heading-page-title" className={styles.header}>
      Advice & services
    </Typography>
    <ul className={styles.list}>
      {relatedLinks.map(({ href, text }, index) => (
        <li key={`${href}-${index}`}>
          <Link href={href ?? ''} textStyle="sb-text-body-default-regular">
            {text}
          </Link>
        </li>
      ))}
    </ul>
  </>
)
